import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { setMailFee, setMailFeeCustomFee, setMailFeeCustomDescription } from '../../redux/modules/registration';
import Dropdown from '../../components/Dropdown';
import precise from '../../modules/precise';
import mailFees from '../../modules/data/mail-fees';
import TextInput from '../../components/TextInput';

class MailFee extends Component {
  constructor(props) {
    super(props);
    this.onValueSelect = this.onValueSelect.bind(this);
    this.onCustomFeeChange = this.onCustomFeeChange.bind(this);
    this.onCustomFeeDescriptionChange = this.onCustomFeeDescriptionChange.bind(this);
    this.state = {
      customFee: '0.00',
      customDescription: '',
    };
  }

  onValueSelect(event) {
    const selectedValue = event.target.value;
    const parts = selectedValue.split('|');
    const name = parts[0];
    const fee = parts[1];
    this.props.setMailFee(name, precise(fee), selectedValue);
  }

  onCustomFeeChange(event) {
    this.props.setMailFeeCustomFee(event.target.value);
  }

  onCustomFeeDescriptionChange(event) {
    this.props.setMailFeeCustomDescription(event.target.value);
  }

  printCustomDescription() {
    const { mailFeeCustomDescription } = this.props;
    if (mailFeeCustomDescription === '') {
      return <span className="Row-subtext">(No Description provided)</span>;
    }
    return mailFeeCustomDescription;
  }

  render() {
    const { mailFee, mailFeeSelectedValue, mailFeeShowCustomAmount, mailFeeCustomDescription, mailFeeCustomFee, mailFeeName } = this.props;
    const hideRowIfZeroInPrint = classNames({
      Row: true,
      'no-print': Number(mailFee) === 0,
    });

    return (
      <div className="Box">
        <div className={hideRowIfZeroInPrint}>

          <TextInput
            id="MFTotal"
            data-id="mailFeeTotal"
            tooltip="Mail Fee Total"
            value={mailFee}
            readOnly
            className="Row-total"
            tabIndex="-1"
          />

          <Dropdown
            id="mailFee"
            tooltip="Choose a listed mail fee or add your own (for example: $10 special mail); the 10 will show and add in the fees. Note you must only use numeric characters for the fee amount."
            options={mailFees}
            onChange={this.onValueSelect}
            selectedValue={mailFeeSelectedValue}
            className="Dropdown Row-dropdown no-print"
          />

          <b className="print-label print-only">Mail Fee: {mailFeeName}</b>

        </div>

        <div className="Row MailFee-custom" style={{ display: mailFeeShowCustomAmount ? 'block' : 'none' }}>

          <input
            id="MFTotalCustom"
            data-id="parkPlacardFee"
            data-tooltip="Mail Fee Total"
            type="number"
            value={mailFeeCustomFee}
            onChange={this.onCustomFeeChange}
            className="Row-total Row-editableTotal"
          />

          <TextInput
            id="MFTotalCustomFeeDescription"
            data-id="mailFeeCustomFeeDescription"
            tooltip="Custom Mail Fee Description"
            placeholder="Description (Optional)"
            onChange={this.onCustomFeeDescriptionChange}
            value={mailFeeCustomDescription}
            className="Row-input Row-longInput no-print"
          />

          <label className="Row-inputLabel no-print" htmlFor="mailFeeCustomFeeDescription">Custom Mail Fee</label>

          <b className="print-label print-only">Custom Mail Fee:&nbsp;</b>
          <span className="print-only">{this.printCustomDescription()}</span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    mailFee: state.registration.mailFee,
    mailFeeName: state.registration.mailFeeName,
    mailFeeSelectedValue: state.registration.mailFeeSelectedValue,
    mailFeeShowCustomAmount: state.registration.mailFeeShowCustomAmount,
    mailFeeCustomFee: state.registration.mailFeeCustomFee,
    mailFeeCustomDescription: state.registration.mailFeeCustomDescription,
  };
};

export default connect(mapStateToProps, { setMailFee, setMailFeeCustomFee, setMailFeeCustomDescription })(MailFee);
